<div class="form-wrapper" style="position: relative;">
  <div class="row">
    <div class="col-lg-12 col-sm-12">
      <h1>Thank you for your submission</h1>
      <h2>You have successfully submitted an Application(s) to the Crime Victim Assistance Program</h2>
      <p>If there is any clarification or additional information needed, a staff member from the Crime Victim Assistance Program will contact you.</p>

      <h2>Other Application Forms</h2>
      <ul>
        <li class="nav-item">
          <a tabindex="2" routerLink="/application/victim" title="Home">Victim Application</a>
        </li>
        <li class="nav-item">
          <a tabindex="2" routerLink="/application/witness" title="Home">Witness Application</a>
        </li>
        <li class="nav-item">
          <a tabindex="2" routerLink="/application/ifm">Immediate Family Member Application</a>
        </li>
      </ul>
      <p><a routerLink="/">Click here for more info on the Crime Victim Assistance Program</a></p>
    </div>
  </div>
</div>